import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { UserService } from '../service'
import { GET_ME, GET_LIST_USERS } from './types'
import type { UserState } from './types'
import orderBy from 'lodash/orderBy'
import type { IUserParameters } from 'interfaces'

const userService = new UserService()

export const actions: ActionTree<UserState, RootState> = {
  actCheckEmailIsUsed(_, params: { email: string }) {
    return userService.checkEmailIsUsed(params.email).then((data) => data.used)
  },
  actGetMe({ commit }) {
    return userService.getMe().then((user) => {
      commit(GET_ME, user)
      return user
    })
  },
  actGetListUsers({ commit }, params: object) {
    return userService.getListUsers(params).then((users) => {
      const transform = orderBy(users, [(u) => new Date(u.updatedAt)], ['desc'])
      commit(GET_LIST_USERS, transform)
      return transform
    })
  },
  actCreateUser(_, params: object) {
    return userService.createUser(params).then((data: any) => data[0])
  },
  actUpdateUser(_, params: IUserParameters) {
    return userService.updateUser(params).then((data: any) => data[0])
  },
  actDeleteUser(_, params: IUserParameters) {
    return userService.deleteUser(params)
  },
  actChangePassword(_, params: object) {
    return userService.changePassword(params)
  },
  actCreateEndUser(_, params: object) {
    return userService.createEndUser(params).then((data: any) => data[0])
  },
  actGetListEndUsers({ commit }, params: object) {
    return userService.getListEndUser(params).then((appUsers) => {
      const transform = orderBy(appUsers, [(u) => new Date(u.updatedAt)], ['desc'])
      commit(GET_LIST_USERS, transform)
      return transform
    })
  },
  actUpdateEndUser(_, params: IUserParameters) {
    return userService.updateEndUser(params).then((data: any) => data[0])
  },
  actDeleteEndUser(_, params: IUserParameters) {
    return userService.deleteEndUser(params)
  },
}
